//*Libraries imports
import { X } from "lucide-react";

type PdfViewerProps = {
  url: string;
  onClose: () => void;
  title?: string;
};

export function PdfViewer({
  url,
  onClose,
  title = "Visualizador de PDF",
}: PdfViewerProps) {
  return (
    <div className="flex flex-col size-full min-h-[80vh] bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-200">
      <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50/50">
        <h2 className="text-sm font-semibold text-gray-700">{title}</h2>
        <button
          onClick={onClose}
          className="p-1.5 hover:bg-gray-200 rounded-full transition-colors text-gray-500"
          title="Fechar visualizador"
        >
          <X size={18} />
        </button>
      </div>
      <div className="flex-1 bg-gray-100 p-2">
        <iframe
          src={url}
          className="size-full min-h-[70vh] rounded-lg border border-gray-200 bg-white"
          title={title}
        />
      </div>
    </div>
  );
}
